import React, { forwardRef, useCallback, useMemo, useState } from 'react'
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { Form, Button } from 'antd';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import _ from 'lodash';
import message from 'components/CustomMessage';
import ClaytonMappingForm from './ClaytonMappingForm';

function ClaytonCredentialsForm(props, ref) {
    const [form] = Form.useForm();
    const [allowAccess, setAllowAccess] = useState(false);

    const handleOauthPopup = useCallback(() => {
        const {apiEndpoint, clientId, scope} = form.getFieldsValue();
        const _window = window.open(`/api/tools/oauth2/authurl?apiEndpoint=${apiEndpoint}&clientId=${clientId}&scope=${scope}`, "_blank", "width=1000,height=800,rel=noopener");
        if(_.isNull(_window)){
            message.error("Pop-up window is blocked on your browser, please enable and retry.");
            return false;
        }
        var timer = setInterval(function() { 
            try {
                // _window becomes null if the popup window is blocked by the browser.
                // User closes the OAuth window before access
                if(!_window || _window.closed) {
                    clearInterval(timer);
                    message.error("Unable to connect to Clayton, please try again.");
                    return;
                }
                if(_window.location.pathname.endsWith("oauth2/code/callback")){
                    const params = new URLSearchParams(_window.location.search);
                    if(params.has("code")){
                        const code = params.get("code");
                        form.setFieldsValue({"verificationCode": code});
                        clearInterval(timer);
                        _window.close();
                    }
                }
            } catch (e) {console.error(e)}
        }, 1000);

        return () => {
            clearInterval(timer);
            _window.close();
        }
    }, [form]);

    const fields = useMemo(() => {
        return [
            {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator]
        },
        {
            name: "clientId",
            label: "Client ID",
            required: true,
        },
        {
            name: "scope",
            label: "Scope",
            required: true
        },
        {
            name: "clientSecret",
            label: "Client Secret",
            required: true,
            type: FieldTypes.PASSWORD,
            props: {
                onChange: (e) => setAllowAccess(e.target.value)
            }
        },
        {
            name: "",
            label: "Allow Access", 
            render: () =>  <Button type="primary" disabled={!allowAccess} onClick={handleOauthPopup}>Allow Access</Button>,
            
        },
        {
            name: "verificationCode",
            label: "Verification Code",
            required: true,
            type: FieldTypes.PASSWORD,
        }]
    },[handleOauthPopup, allowAccess])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            form={form}
            fields={fields}
            MappingForm={ClaytonMappingForm}
            initialValue={{ apiEndpoint: 'https://app.clayton.io', scope: "workspace" }}
        />
    )
}

export default forwardRef(ClaytonCredentialsForm);